global.lottie = require('lottie-web/build/player/lottie_light')
